import React from 'react';

const Loading = (props) => <i className="fa fa-spinner fa-spin"></i>;

export default Loading;



// WEBPACK FOOTER //
// ./src/Loading.js